export default {
  title: 'Settings',
  subtitle: 'Customize your application preferences.',
  saveSettings: 'Save Settings',
  settingsSaved: 'Settings saved successfully',

  // Notifications section
  notifications: {
    title: 'Notifications',
    enable: 'Enable notifications',
    email: 'Email notifications',
    emailDesc: 'Receive email notifications for important events',
    inApp: 'In-app notifications',
    inAppDesc: 'Display notifications in the application interface',
    lateReturn: 'Late return alerts',
    lateReturnDesc: 'Receive alerts for late returns',
    options: 'Notification Options'
  },

  // Language section
  language: {
    title: 'Language & Region',
    selectLanguage: 'Select Language',
    currentLanguage: 'Current Language',
    english: 'English',
    french: 'Français'
  }
};
